import React from 'react'
import { Button as MuiButton, useTheme } from '@mui/material'
import { Loader } from 'packages/eid-ui'

const Button = (props) => {
    const {
        loading,
        color,
        disabled,
        onClick,
        children,
        rootStylesProp,
        ...rest
    } = props

    const theme = useTheme()

    return (
        <MuiButton
            disabled={disabled}
            variant="contained"
            onClick={onClick}
            sx={{
                textTransform: 'capitalize !important',
                fontSize: '16px',
                color: theme?.palette?.common?.white,
                backgroundColor: color,
                boxShadow: 'none',
                '&:hover': {
                    boxShadow: 'none',
                    backgroundColor: color,
                    '&::before': {
                        borderRadius: 'inherit',
                        content: '""',
                        position: 'absolute',
                        height: '100%',
                        width: '100%',
                        opacity: '0.17',
                        backgroundColor: theme?.palette?.common?.black,
                        left: 0,
                        top: 0,
                    },
                },
                '&:active': {
                    boxShadow: 'none',
                    backgroundColor: color,
                    opacity: 0.7,
                },
                '&:focus': {
                    boxShadow: 'none',
                },
                ...rootStylesProp,
                '&.Mui-disabled': {
                    color: `${theme?.palette?.common?.white} !important`,
                },
            }}
            {...rest}
        >
            {loading ? (
                <Loader color={theme?.palette?.common?.white} />
            ) : (
                children
            )}
        </MuiButton>
    )
}
export default Button
